/* AWP Join the Team page: video facade and thank-you form. */
(function () {
  var root = document.querySelector('.awpj');
  if (!root) return;

  // Video: the poster swaps to the YouTube player on click. Captions start off
  // (YouTube remembers a viewer's last CC choice), but the CC button still works.
  var v = root.querySelector('[data-awpj-video]');
  if (v) v.addEventListener('click', function () {
    var id = v.getAttribute('data-awpj-video');
    if (!id) return;
    var box = document.createElement('div');
    box.className = 'vid';
    var slot = document.createElement('div');
    box.appendChild(slot);
    v.replaceWith(box);

    function start() {
      var capsOffUntil = Date.now() + 4000;
      var player = new YT.Player(slot, {
        host: 'https://www.youtube-nocookie.com',
        videoId: id,
        playerVars: { autoplay: 1, rel: 0, playsinline: 1, cc_load_policy: 0 },
        events: {
          onReady: function (e) { e.target.playVideo(); },
          onStateChange: function (e) {
            if (e.data === 1 && Date.now() < capsOffUntil) player.unloadModule('captions');
          },
          onApiChange: function () {
            // Only in the first seconds, so a viewer who taps CC later keeps them.
            if (Date.now() < capsOffUntil) player.unloadModule('captions');
          }
        }
      });
    }
    if (window.YT && window.YT.Player) return start();
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () { if (prev) prev(); start(); };
    var s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(s);
  });

  // Thank-you form: the monthly plan only goes with the order when Every month is picked.
  var form = root.querySelector('[data-awpj-thanks]');
  if (form) {
    var plan = form.querySelector('[data-awpj-plan]');
    form.querySelectorAll('input[name="awpj_freq"]').forEach(function (r) {
      r.addEventListener('change', function () { if (plan) plan.disabled = (form.querySelector('input[name="awpj_freq"]:checked').value !== 'monthly'); });
    });
  }
})();
